exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\r\n  height: 56px;\r\n  background-color:white;\r\n  width: 100%;\r\n  box-shadow: inset 0px 6px 10px 0px rgba(0,0,0,0.06);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/header/header.component.css
// module id = ../../../../../src/app/layout/home/header/header.component.css
// module chunks = main